<template>
  <div class="flex gap-6 items-start">
    <div ref="textContainer">
      <slot name="text" />
    </div>
    <div ref="videoContainer">
      <slot name="video" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicHeighVideoContainer',
  data () {
    return {
      rafId: null,
      resizeObserver: null,
      resizeHandler: null,
      loadHandler: null,
      videoLoadedMetadataHandler: null,
      timeoutId: null,
    }
  },
  mounted () {
    this.resizeHandler = () => this.scheduleSync()
    this.loadHandler = () => this.scheduleSync()
    this.videoLoadedMetadataHandler = () => this.scheduleSync()

    this.$nextTick(() => this.scheduleSync())

    if (window.ResizeObserver && this.$refs.textContainer) {
      this.resizeObserver = new ResizeObserver(() => this.scheduleSync())
      this.resizeObserver.observe(this.$refs.textContainer)
    }

    window.addEventListener('resize', this.resizeHandler)
    window.addEventListener('load', this.loadHandler)

    const videoElement = this.getVideoElement()
    if (videoElement) {
      videoElement.addEventListener('loadedmetadata', this.videoLoadedMetadataHandler)
    }

    this.timeoutId = window.setTimeout(() => {
      this.timeoutId = null
      this.scheduleSync()
    }, 200)
  },
  beforeUnmount () {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId)
      this.rafId = null
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }

    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }

    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
      this.resizeHandler = null
    }

    if (this.loadHandler) {
      window.removeEventListener('load', this.loadHandler)
      this.loadHandler = null
    }

    if (this.videoLoadedMetadataHandler) {
      const videoElement = this.getVideoElement()
      if (videoElement) {
        videoElement.removeEventListener('loadedmetadata', this.videoLoadedMetadataHandler)
      }
      this.videoLoadedMetadataHandler = null
    }
  },
  methods: {
    getVideoElement () {
      if (!this.$refs.videoContainer) return null
      return this.$refs.videoContainer.querySelector('video')
    },
    scheduleSync () {
      if (this.rafId !== null) return
      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null
        this.syncVideoHeight()
      })
    },
    syncVideoHeight () {
      if (!this.$refs.textContainer) return

      const videoElement = this.getVideoElement()
      if (!videoElement) return

      const textHeight = this.$refs.textContainer.getBoundingClientRect().height
      if (textHeight > 0 && videoElement.style.height !== `${textHeight}px`) {
        videoElement.style.height = `${textHeight}px`
      }
    },
  },
}
</script>

<style scoped>
</style>
